import { render, staticRenderFns } from "./OrdOutputProductEdit.vue?vue&type=template&id=121a89d2&"
import script from "./OrdOutputProductEdit.vue?vue&type=script&lang=js&"
export * from "./OrdOutputProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports